import { Outlet, useNavigate, NavLink, Navigate } from "react-router-dom";
import { userLoggedOut } from "../../features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../hooks/useAuth";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

export default function StudentLayout() {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { name } = useSelector(state => state?.auth?.user) || {}

  const logout = () => {
    dispatch(userLoggedOut());
    localStorage.clear();
    navigate('/', { replace: true })
  };

  const { isLoggedIn, role } = useAuth()
  if (!isLoggedIn || role !== 'student') return <Navigate to={'/'} replace={true} />

  return (
    <>
      <nav className="shadow-md navbar">
        <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
          <img className="h-10" src="../assets/image/learningportal.svg" />
          <div className="flex items-center gap-4 select-none ">
            <NavLink className={`navitem`} to="/leaderboard">Leaderboard</NavLink> |
            <NavLink className={`navitem`} to="/course">Course</NavLink> 
            <h2 className="font-bold select-none capitalize flex gap-1 items-center border rounded-lg px-2 py-1">
              <UserOutlined />
              {name}
            </h2>
            <div onClick={logout} className="flex cursor-pointer gap-2 border border-cyan items-center px-4 py-1 rounded-full text-sm transition-all hover:bg-cyan ">
              <LogoutOutlined/>
              Logout
            </div>
          </div>
        </div>
      </nav>
      <Outlet />
    </>
  )
}